function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import React, { Component } from 'react';
import ProviderIntent from '../components/ProviderIntent.js';
import { providerIntents } from '../consts.js';
import providerEvents from 'wix-art-store-3rd-party/dist/src/sdk/providerEvents';
import WixSDKProviderApi from '../components/WixSDKProviderApi';
import createWixSdk from '../gallery/wixSdkOOI';
var ThankyouIntentOOI = /*#__PURE__*/function (_Component) {
  function ThankyouIntentOOI(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      height: null
    };
    return _this;
  }
  _inheritsLoose(ThankyouIntentOOI, _Component);
  var _proto = ThankyouIntentOOI.prototype;
  _proto.handleThankyouMessageReceived = function handleThankyouMessageReceived(type, payload, resolve, reject) {
    var storeApi = this.props.storeApi;
    switch (type) {
      case providerEvents.setHeight:
        this.setState({
          height: payload.height
        });
        break;
      case providerEvents.clearCart:
        storeApi.clearCart();
        break;
      case providerEvents.backHome:
        storeApi.backHome();
        break;
      default:
        break;
    }
  };
  _proto.init = function init() {
    this.props.tryToReportAppLoaded();
    if (!this.wixSdk) {
      var _this$props = this.props,
        baseUrl = _this$props.baseUrl,
        sectionsUrls = _this$props.sectionsUrls,
        visitorId = _this$props.visitorId,
        metaSiteId = _this$props.metaSiteId,
        locale = _this$props.locale,
        _this$props$host = _this$props.host,
        formFactor = _this$props$host.formFactor,
        style = _this$props$host.style;
      var getDeviceType = function getDeviceType(type) {
        return type === 'mobile' || type === 'tablet' ? 'mobile' : 'desktop';
      };
      this.wixSdk = createWixSdk({
        baseUrl: baseUrl,
        sectionsUrls: sectionsUrls,
        visitorId: visitorId,
        metaSiteId: metaSiteId,
        locale: locale,
        deviceType: getDeviceType(formFactor.toLowerCase()),
        style: style
      });
    }
  };
  _proto.getConsentPolicyQuery = function getConsentPolicyQuery(consentPolicy) {
    if (consentPolicy && consentPolicy.policy) {
      return encodeURIComponent(JSON.stringify(consentPolicy));
    } else {
      return undefined;
    }
  };
  _proto.getQueryParams = function getQueryParams() {
    var _this$props2 = this.props,
      consentPolicy = _this$props2.consentPolicy,
      queryParams = _this$props2.queryParams;
    var search = queryParams;
    var _consentPolicy = consentPolicy || queryParams.consentPolicy;
    if (_consentPolicy) {
      search.consentPolicy = this.getConsentPolicyQuery(_consentPolicy);
    }
    return search;
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props3 = this.props,
      connectedProviders = _this$props3.connectedProviders,
      host = _this$props3.host;
    if (!connectedProviders) {
      return null;
    }
    this.init();
    var height = this.state.height;
    var styles = height ? {
      height: height + 'px'
    } : {};
    return /*#__PURE__*/React.createElement("div", {
      style: styles
    }, /*#__PURE__*/React.createElement(ProviderIntent, {
      api: new WixSDKProviderApi(this.wixSdk),
      connectedProviders: connectedProviders,
      hiddenFromEditor: true,
      ref: function ref(element) {
        return _this2.intent = element;
      },
      viewMode: host.viewMode.toLowerCase(),
      intent: providerIntents.thankyou,
      onMessageReceived: function onMessageReceived(type, payload, resolve, reject, providerId) {
        return _this2.handleThankyouMessageReceived(type, payload, resolve, reject, providerId);
      },
      additionalParams: this.getQueryParams()
    }));
  };
  return ThankyouIntentOOI;
}(Component);
export default ThankyouIntentOOI;